import React from "react";

const SearchAccordion = ({
  icon,
  style,
  index,
  accordionId,
  title,
  data,
  handleTagClick
}) => {
  //console.logdata, "data---");
  //console.logdata, "my-search");
  return (
    <>
      <div className="container-fluid w-75">
        <div className="accordion" id={accordionId}>
          <div className="accordion-item">
            <h2 className="accordion-header" id={`heading${index}`}>
              <button
                className="accordion-button collapsed"
                type="button"
                data-bs-toggle="collapse"
                data-bs-target={`#collapse${index}`}
                aria-expanded="false"
                aria-controls={`collapse${index}`}
              >
                <img src={icon} style={style} alt="" className="me-2 accordion-icon" />
                <span className="accordion-title">{title}</span>
              </button>
            </h2>
            <div
              id={`collapse${index}`}
              className="accordion-collapse collapse"
              aria-labelledby={`heading${index}`}
              data-bs-parent={`#${accordionId}`}
            >
              <div className="accordion-body">
                {!!data &&
                  data?.map((item, index) => (
                    <React.Fragment key={index}>
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => handleTagClick("category", item?.categoryId)}
                        className="badge rounded-pill bg-white text-dark p-2 shadow mx-2 my-1 badge-text"
                      >
                        {item?.category && item?.category }
                      </span>
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => handleTagClick("subCategory", item?.subCategoryId)}
                        className="badge rounded-pill bg-white text-dark p-2 shadow mx-2 my-1 badge-text"
                      >
                        {item?.subCategory && item?.subCategory}
                      </span>
                      <span
                        style={{ cursor: "pointer" }}
                        onClick={() => handleTagClick("location", item?.location)}
                        className="badge rounded-pill bg-white text-dark p-2 shadow mx-2 my-1 badge-text"
                      >
                        {item?.location}
                      </span>
                    </React.Fragment>
                  ))}
              </div>
            </div>
          </div>
        </div>
      </div>
      <style jsx>{`
        .accordion-button {
          display: flex;
          align-items: center;
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .accordion-icon {
          flex-shrink: 0;
        }
        .accordion-title {
          flex-grow: 1;
          margin-left: 10px;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        .badge-text {
          display: inline-block;
          max-width: 100px; /* Adjust based on your design */
          white-space: nowrap;
          overflow: hidden;
          text-overflow: ellipsis;
        }
        @media (max-width: 576px) {
          .accordion-button {
            font-size: 14px;
            padding: 0.5rem 1rem;
          }
          .accordion-body {
            font-size: 14px;
          }
          .badge {
            padding: 0.4rem 0.6rem;
          }
        }
      `}</style>
    </>
  );
};

export default SearchAccordion;
